<nb-icon (click)="clicked()"
         [nbTooltip]="('admin.modules.places.no_place_warning' | translate)"
         status="warning"
         icon="exclamation-triangle">
</nb-icon>
